import React, { useState } from "react";
import Swal from "sweetalert2";
import { submitFallbackDetails } from "../../../../api/Api";
import { getFromLocalStorage } from "../../../../utils/common-utils";
import Loader from "../../../../components/loader/loader";
import "./Fallback.css";
export default function FallbackTabs({ productId, setActiveTab, onComplete }) {
  const [isFallbackEnabled, setIsFallbackEnabled] = useState(false);
  const [fallbackRows, setFallbackRows] = useState([
    {
      id: 1,
      price: "",
      validity: "",
      status: true,
      isApproved: 1,
    },
  ]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const handleFallbackChange = (e) => {
    const value = e.target.value === "Yes";
    setIsFallbackEnabled(value);
    if (!value) {
      setFallbackRows([
        {
          id: 1,
          price: "",
          validity: "",
          status: true,
          isApproved: 1,
        },
      ]);
    }
  };

  const handleAddRow = () => {
    setFallbackRows([
      ...fallbackRows,
      {
        id: fallbackRows.length + 1,
        price: "",
        validity: "",
        status: true,
        isApproved: 1,
      },
    ]);
  };

  const handleRemoveRow = (index) => {
    const updatedRows = fallbackRows.filter((_, idx) => idx !== index);
    setFallbackRows(updatedRows);
  };

  const validatePositiveInteger = (value, maxDigits) => {
    const numValue = parseInt(value);
    return value === '' || (
      Number.isInteger(numValue) &&
      numValue >= 0 &&
      value.toString().length <= maxDigits
    );
  };

  const handleRowChange = (index, field, value) => {
    if (field === 'price' || field === 'validity') {
      if (!validatePositiveInteger(value, 3)) {
        return;
      }
    }

    const updatedRows = fallbackRows.map((row, idx) => {
      if (idx === index) {
        return { ...row, [field]: value };
      }
      return row;
    });
    setFallbackRows(updatedRows);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    if (isFallbackEnabled) {
      const hasEmptyFields = fallbackRows.some(row => !row.price || !row.validity);
      if (hasEmptyFields) {
        Swal.fire({
          icon: "error",
          text: "Please fill all mandatory fields",
        });
        return;
      }
    }

    try {
      setIsLoading(true);
      const payload = {
        userId: getFromLocalStorage("userData")?.id,
        productId: productId,
        isFallback: isFallbackEnabled,
        productFallbackList: isFallbackEnabled ? fallbackRows : [],
      };

      const response = await submitFallbackDetails(payload);

      if (response?.statusDescription?.status === 200) {
        Swal.fire({
          icon: "success",
          text:
            response?.statusDescription?.description ||
            "Fallback details saved successfully!",
        }).then(() => {
          onComplete();
          setActiveTab("sms");
        });
      } else {
        Swal.fire({
          icon: "error",
          text:
            response?.statusDescription?.description ||
            "Failed to save fallback details",
        });
      }
    } catch (error) {
      console.error("Error submitting fallback details:", error);
      Swal.fire({
        icon: "error",
        text: "Failed to save fallback details",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
    {isLoading && <Loader />}
    {/* <div className="tab-content"> */}
      <div className="tab-pane active">
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>Fallback<span className="text-danger">*</span></label>
              <div className="d-flex align-items-center">
                <input
                  type="radio"
                  name="fallback"
                  value="Yes"
                  checked={isFallbackEnabled}
                  onChange={handleFallbackChange}
                />{" "}
                <span className="ml-1">Yes</span>
                <input
                  type="radio"
                  name="fallback"
                  value="No"
                  checked={!isFallbackEnabled}
                  onChange={handleFallbackChange}
                  className="ml-3"
                />{" "}
                <span className="ml-1">No</span>
              </div>
            </div>
          </div>
          {/* {isFallbackEnabled && (
            <>
              {fallbackRows.map((row, index) => (
                <>
                  <div  className="col-md-4">
                    <div className="form-group mb-0">
                      <label>Price<span className="text-danger">*</span></label>
                      <input
                        type="number"
                        className={`form-control ${isSubmitted && !row.price ? 'is-invalid' : ''}`}
                        value={row.price}
                        onChange={(e) => handleRowChange(index, "price", e.target.value)}
                        onKeyPress={(e) => {
                          if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                            e.preventDefault();
                          }
                        }}
                        min="0"
                        max="999"
                        placeholder="Price in Local Currency"
                        onWheel={(e) => e.target.blur()}
                      />
                      {isSubmitted && !row.price && (
                        <div className="invalid-feedback">
                          Price is required
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group mb-0">
                      <label>Validity (In Days)<span className="text-danger">*</span></label>
                      <input
                        type="number"
                        className={`form-control ${isSubmitted && !row.validity ? 'is-invalid' : ''}`}
                        value={row.validity}
                        onChange={(e) => handleRowChange(index, "validity", e.target.value)}
                        onKeyPress={(e) => {
                          if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                            e.preventDefault();
                          }
                        }}
                        min="0"
                        max="999"
                        placeholder="Enter Validity"
                        onWheel={(e) => e.target.blur()}
                      />
                      {isSubmitted && !row.validity && (
                        <div className="invalid-feedback">
                          Validity is required
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-1 d-flex align-items-end">
                    <div className="form-group mb-0 d-flex">
                      {fallbackRows.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-danger mr-2"
                          onClick={() => handleRemoveRow(index)}
                        >
                          -
                        </button>
                      )}
                      {index === fallbackRows.length - 1 && (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleAddRow}
                        >
                          +
                        </button>
                      )}
                    </div>
                  </div>
                </>
              ))}
              </>
          )} */}
        </div>

        {isFallbackEnabled && (
          <div className="mt-3">
            {fallbackRows.map((row, index) => (
              <div key={row.id} className="row mb-3 align-items-end">
                <div className="form-group mb-0 col-md-4 price">
                  {/* <div className="form-group mb-0"> */}
                    <label>Price<span className="text-danger">*</span></label>
                    <input
                      type="number"
                      className={`form-control ${isSubmitted && !row.price ? 'is-invalid' : ''}`}
                      value={row.price}
                      onChange={(e) => handleRowChange(index, "price", e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                          e.preventDefault();
                        }
                      }}
                      min="0"
                      max="999"
                      placeholder="Price in Local Currency"
                      onWheel={(e) => e.target.blur()}
                    />
                    {isSubmitted && !row.price && (
                      <div className="invalid-feedback">
                        Price is required
                      </div>
                    )}
                  {/* </div> */}
                </div>
                <div className="form-group mb-0 col-md-4 validity">
                  {/* <div className="form-group mb-0"> */}
                    <label>Validity (In Days)<span className="text-danger">*</span></label>
                    <input
                      type="number"
                      className={`form-control ${isSubmitted && !row.validity ? 'is-invalid' : ''}`}
                      value={row.validity}
                      onChange={(e) => handleRowChange(index, "validity", e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                          e.preventDefault();
                        }
                      }}
                      min="0"
                      max="999"
                      placeholder="Enter Validity"
                      onWheel={(e) => e.target.blur()}
                    />
                    {isSubmitted && !row.validity && (
                      <div className="invalid-feedback">
                        Validity is required
                      </div>
                    )}
                  {/* </div> */}
                </div>
                <div className="col-md-4 plus_minus ps-0">
                  <div className="form-group mb-0 d-flex mt-md-0 mt-3">
                    {fallbackRows.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger mr-2 py-1 minus"
                        onClick={() => handleRemoveRow(index)}
                      >
                        -
                      </button>
                    )}
                    {index === fallbackRows.length - 1 && (
                      <button
                        type="button"
                        className="btn btn-primary py-1 plus"
                        onClick={handleAddRow}
                      >
                        +
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="row mt-4">
          <div className="col-md-12 text-right d-flex justify-content-between buttons_divs">
            <button
              type="button"
              className="btn btn-secondary mr-2"
              onClick={() => setActiveTab("chargingConfig")}
            >
              Previous
            </button>
            <div>
             
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                Save & Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    {/* </div> */}
    </>
  );
}
